import { render } from "./head.vue?vue&type=template&id=56ecbb7b&scoped=true"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=56ecbb7b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56ecbb7b"

export default script